var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "d-flex align-items-center uk-visible@m" },
      [
        _c("p", { staticClass: "my-0 me-3" }, [_vm._v("Gekozen filters")]),
        _vm._v(" "),
        _c("div", { staticClass: "active-filter me-2" }, [
          _c("span", [_vm._v("Dames")]),
          _c("i", { staticClass: "fa-solid fa-xmark" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "active-filter" }, [
          _c("span", [_vm._v("Unisex")]),
          _c("i", { staticClass: "fa-solid fa-xmark" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }